import Cookies from 'js-cookie';

export function getCookie(name: string) {
  return Cookies.get(name);
}

export function setCookie(name:string, value: string, days: number) {
  Cookies.set(name, value, { expires: days });
}
